module.exports = __webpack_public_path__ + "static/media/values_complete.546f807d.png";